import React from 'react';
import ChatTemplate from '~src/components/templates/Chat';

const AdminChat = () => (<ChatTemplate />);

export default AdminChat;
